import React from "react";

class ChangePercantage extends React.PureComponent {
  percIncrease(a, b) {
    let percent;
    if (b !== 0) {
      if (a !== 0) {
        percent = ((b - a) / a) * 100;
      } else {
        percent = 100;
      }
    } else {
      percent = -100;
    }
    return Math.floor(percent);
  }

  render() {
    const {
      props: { current, previous },
    } = this;

    const change = this.percIncrease(previous, current);
    return (
      <span
        className={
          change === 0
            ? "zerochange"
            : change > 0
            ? "positivechange"
            : "negativechange"
        }
      >
        {change}%
      </span>
    );
  }
}

export default ChangePercantage;
